(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'babel-runtime/helpers/extends', '../../styles/colors', '../../styles/fonts/fonts'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/helpers/extends'), require('../../styles/colors'), require('../../styles/fonts/fonts'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global._extends, global.colors, global.fonts);
    global.ButtonsCss = mod.exports;
  }
})(this, function (exports, _extends2, _colors, _fonts) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.buttonFlatSmallStyles = exports.buttonFlatLargeStyles = exports.buttonSecondarySmallStyles = exports.buttonSecondaryLargeStyles = exports.buttonPrimarySmallStyles = exports.buttonPrimaryLargeStyles = exports.buttonFlatLoadingStyles = exports.buttonSecondaryLoadingStyles = exports.buttonPrimaryLoadingStyles = exports.buttonLoadingStyles = exports.buttonFlatStyles = exports.buttonSecondaryStyles = exports.buttonPrimaryStyles = exports.buttonSmallStyles = exports.buttonLargeStyles = exports.buttonCoreStyles = undefined;

  var _extends3 = _interopRequireDefault(_extends2);

  var _colors2 = _interopRequireDefault(_colors);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var jungle = _colors2.default.jungle,
      slate = _colors2.default.slate,
      white = _colors2.default.white,
      stone = _colors2.default.stone,
      silver = _colors2.default.silver;
  var buttonCoreStyles = exports.buttonCoreStyles = {
    textTransform: 'none',
    fontStyle: 'normal',
    fontStretch: 'normal',
    fontFamily: _fonts.ProximaNova,
    boxShadow: 'none',
    wordWrap: 'normal',
    '&:focus': {
      outline: 'none'
    }
  };

  var buttonLargeStyles = exports.buttonLargeStyles = {
    fontSize: '1rem',
    padding: '1rem 2rem',
    borderRadius: '4px',
    lineHeight: '1.5',
    '&:hover': {
      boxShadow: '0 2px 2px 0 rgba(0, 0, 0, 0.24), 0 0 2px 0 rgba(0, 0, 0, 0.12)'
    },
    '&:active': {
      boxShadow: '0 8px 8px 0 rgba(0, 0, 0, 0.24), 0 0 8px 0 rgba(0, 0, 0, 0.12)'
    },
    '&:focus': {
      boxShadow: '0 2px 2px 0 rgba(0, 0, 0, 0.24), 0 0 2px 0 rgba(0, 0, 0, 0.12)',
      outline: 'none'
    }
  };

  var buttonSmallStyles = exports.buttonSmallStyles = {
    fontSize: '0.8125rem',
    padding: '0.5rem 1rem',
    borderRadius: '3px',
    lineHeight: '1.23',
    '&:hover': {
      boxShadow: '0 2px 2px 0 rgba(0, 0, 0, 0.24), 0 0 2px 0 rgba(0, 0, 0, 0.12)'
    },
    '&:active': {
      boxShadow: '0 8px 8px 0 rgba(0, 0, 0, 0.24), 0 0 8px 0 rgba(0, 0, 0, 0.12)'
    },
    '&:focus': {
      boxShadow: '0 2px 2px 0 rgba(0, 0, 0, 0.24), 0 0 2px 0 rgba(0, 0, 0, 0.12)',
      outline: 'none'
    }
  };

  var buttonPrimaryStyles = exports.buttonPrimaryStyles = {
    backgroundColor: jungle,
    color: white,
    fontFamily: _fonts.ProximaNovaA,

    '&:hover': {
      backgroundColor: jungle,
      boxShadow: '0 0 2px 0 rgba(0, 0, 0, 0.12), 0 2px 2px 0 rgba(0, 0, 0, 0.24)'
    },
    '&:not([disabled]):not(.disabled):active': {
      backgroundColor: jungle,
      boxShadow: '0 8px 8px 0 rgba(0, 0, 0, 0.24), 0 0 8px 0 rgba(0, 0, 0, 0.12)'
    },
    '&:disabled, &[disabled], &.disabled': {
      opacity: 1,
      backgroundColor: '#dedede',
      color: slate,
      fontWeight: 'normal'
    }
  };

  var buttonSecondaryStyles = exports.buttonSecondaryStyles = {
    backgroundColor: 'transparent',
    color: jungle,
    border: '1px solid ' + jungle,
    '&:hover': {
      color: jungle,
      backgroundColor: 'transparent',
      boxShadow: '0 2px 2px 0 rgba(0, 0, 0, 0.24), 0 0 2px 0 rgba(0, 0, 0, 0.12)'
    },
    '&:not([disabled]):not(.disabled):active': {
      backgroundColor: 'rgba(0, 0, 0, 0.1)',
      boxShadow: '0 8px 8px 0 rgba(0, 0, 0, 0.24), 0 0 8px 0 rgba(0, 0, 0, 0.12)'
    },
    '&:disabled, &[disabled], &.disabled': {
      backgroundColor: '#dedede',
      color: '#a3a3a3',
      border: 0,
      opacity: 1
    }
  };

  var buttonFlatStyles = exports.buttonFlatStyles = {
    backgroundColor: 'transparent',
    color: jungle,
    border: 0,
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
      boxShadow: 'none'
    },
    '&:not([disabled]):not(.disabled):active': {
      backgroundColor: silver,
      boxShadow: 'none'
    },
    '&:disabled, &[disabled], &.disabled': {
      backgroundColor: 'transparent',
      color: stone,
      opacity: 1
    }
  };

  var buttonLoadingStyles = exports.buttonLoadingStyles = {
    labelWhileLoading: {
      color: 'transparent'
    },
    spinnerContainer: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)'
    }
  };

  var buttonPrimaryLoadingStyles = exports.buttonPrimaryLoadingStyles = {
    spinner: {
      stroke: white,
      '&&': {
        stroke: white
      }
    }
  };

  var buttonSecondaryLoadingStyles = exports.buttonSecondaryLoadingStyles = {
    spinner: {
      stroke: jungle,
      '&&': {
        stroke: jungle
      }
    }
  };

  var buttonFlatLoadingStyles = exports.buttonFlatLoadingStyles = {
    spinner: {
      stroke: jungle,
      '&&': {
        stroke: jungle
      }
    }
  };

  var buttonPrimaryLargeStyles = exports.buttonPrimaryLargeStyles = (0, _extends3.default)({}, buttonLoadingStyles, buttonPrimaryLoadingStyles, {
    root: (0, _extends3.default)({}, buttonCoreStyles, buttonLargeStyles, buttonPrimaryStyles)
  });

  var buttonPrimarySmallStyles = exports.buttonPrimarySmallStyles = (0, _extends3.default)({}, buttonLoadingStyles, buttonPrimaryLoadingStyles, {
    root: (0, _extends3.default)({}, buttonCoreStyles, buttonSmallStyles, buttonPrimaryStyles)
  });

  var buttonSecondaryLargeStyles = exports.buttonSecondaryLargeStyles = (0, _extends3.default)({}, buttonLoadingStyles, buttonSecondaryLoadingStyles, {
    root: (0, _extends3.default)({}, buttonCoreStyles, buttonLargeStyles, buttonSecondaryStyles)
  });

  var buttonSecondarySmallStyles = exports.buttonSecondarySmallStyles = (0, _extends3.default)({}, buttonLoadingStyles, buttonSecondaryLoadingStyles, {
    root: (0, _extends3.default)({}, buttonCoreStyles, buttonSmallStyles, buttonSecondaryStyles)
  });

  var buttonFlatLargeStyles = exports.buttonFlatLargeStyles = (0, _extends3.default)({}, buttonLoadingStyles, buttonFlatLoadingStyles, {
    root: (0, _extends3.default)({}, buttonCoreStyles, buttonLargeStyles, buttonFlatStyles)
  });

  var buttonFlatSmallStyles = exports.buttonFlatSmallStyles = (0, _extends3.default)({}, buttonLoadingStyles, buttonFlatLoadingStyles, {
    root: (0, _extends3.default)({}, buttonCoreStyles, buttonSmallStyles, buttonFlatStyles)
  });
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/components/Buttons/Buttons.css.js
// module id = 857
// module chunks = 1